import styled from '@emotion/styled';
import { Card } from 'antd';

export const StyledGeneralCard = styled(Card)`
  margin-bottom: 8px;
`;
